export const normalizePortalEmail = (value) => String(value || '').trim().toLowerCase();

export const isValidPortalEmail = (value) => {
  const normalizedEmail = normalizePortalEmail(value);
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail);
};

export const getPasswordResetErrorMessage = (error) => {
  const status = error?.response?.status;
  const responseMessage =
    typeof error?.response?.data === 'string'
      ? error.response.data
      : error?.response?.data?.message;

  if (status === 404) {
    return responseMessage || 'We could not find a teacher account using that email address.';
  }
  if (status === 429) {
    return 'Too many reset attempts were made. Please wait a few minutes and try again.';
  }
  if (!error?.response) {
    return 'We could not reach the password reset service. Check your connection and try again.';
  }

  return responseMessage || 'We could not send the reset email. Please try again or contact your academy administrator.';
};

